import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class ErrorModal extends Component {
  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <strong>Error Details: </strong>
          {this.props.error}
        </Modal.Body>
      </Modal>
    );
  }
}

export default ErrorModal;



// WEBPACK FOOTER //
// ./src/containers/User/Common/ErrorModal/ErrorModal.js